/**
 * Coerce any thrown value into a human-readable message.
 *
 * Prefer `Error.message`, fall back to any object with a `.message`
 * property (Supabase errors use this shape), else a generic string.
 */
export function readError(err: unknown): string {
  if (err instanceof Error) return err.message
  if (typeof err === 'object' && err !== null && 'message' in err) {
    return String((err as { message: unknown }).message)
  }
  return 'Something went wrong'
}
